(function () {
    'use strict';

    angular
        .module('app')
        .controller('folderbrowser', folderbrowser);

    folderbrowser.$inject = ['$q', '$timeout', 'folderBrowserService'];

    function folderbrowser($q, $timeout, folderBrowserService) {
        /* jshint validthis:true */
        var vm = this;
        var newId = 1;
        vm.ignoreChanges = false;
        vm.newNode = {};
        vm.folderBrowserService = folderBrowserService;
        vm.selectedNode = null;

        vm.treeData = function (node, cb) {            
            if (node.id === "#") {
                folderBrowserService.getDrives().then(function (data) {
                    cb(data);
                    if (folderBrowserService.path) {
                        $timeout(function () {
                            folderBrowserService.verifyDirectory(folderBrowserService.path).then(function (data) {
                                if (data == true) {
                                    vm.treeControl.navigateTo(folderBrowserService.path);
                                }
                                else {
                                    vm.selectedNode = null;
                                }
                            }, function () {
                                deferred.reject(obj);
                            });
                        }, 100);
                    }
                    
                });
            }
            else {
                folderBrowserService.getDirectories(node.data).then(function (data) {
                    cb(data);
                }, function () {
                    cb([]);
                });
            }
        };

        vm.onRename = function (obj) {
            var deferred = $q.defer();
            //var start = obj.node.data.lastIndexOf("\\") + 1;
            //var name = obj.node.data.substring(start);
            var newPath = obj.node.data.replace(obj.old, obj.text);
            if (newPath != obj.node.data) {
                folderBrowserService.renameDirectory(obj.node.data, newPath).then(function (data) {
                    obj.node.data = newPath;
                    deferred.resolve(obj);
                }, function () {
                    deferred.reject(obj);
                });
            }           
            return deferred.promise;
        }

        vm.onCreate = function (node) {
            var deferred = $q.defer();
            if (!endsWith(node.data, "\\")) {
                node.data = node.data + "\\";
            }
            var path = node.data + "NewFolder";
            folderBrowserService.createDirectory(path).then(function (data) {
                deferred.resolve(data);
            }, function (data) {
                deferred.reject(data);
            });
            return deferred.promise;
        }

        vm.ok = function () {
            folderBrowserService.close(vm.selectedNode);
        }

        vm.cancel = function () {
            folderBrowserService.cancel();
        }

        function endsWith(str, suffix) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }
        vm.treeControl = {};
        vm.navigateTo = function () {
            
        }

        activate();

        function activate() { }
    }
})();
